import { errorServeiceHandler, makeQueryStringDync, makeQueryFormDataDyn } from "../helper";
const state = {};
const getters = {};
const mutations = {};
const actions = {
    getInstantCustomerDetailsOTT: (context, filterData) => {
        console.log("called customer details");
        let url = '/subscriber/v1/subscriber/ottquickpay'
        return new Promise((resolve, reject) => {
            let queryStr = ''
            queryStr = makeQueryStringDync(filterData)
            fetch(context.getters.baseUrl + url + queryStr, {
                    method: 'GET'
                })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    if (context.getters.getMode == "development") {
                        resolve({ "subscribername": "Neena Aidasani", "email": "", "mobileno": 9987505831, "susbcriberstatus": "A", "accountno": 23397361, "region": "MUM", "currentbalance": -223, "frcode": "DP0001", "customertype": "DP", "customeridentity": null })
                        return
                    }
                    reject(error)
                });
        });
    },
    getQRCustomerPlans: (context, filterData) => {
        let url = '/subscriber/v1/qrplan/listplan'
        return new Promise((resolve, reject) => {
            let queryStr = ''
            queryStr = makeQueryStringDync(filterData)
            fetch(context.getters.baseUrl + url + queryStr, {
                    method: 'GET'
                })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    reject(error)
                });
        });
    },
    getOttPacks: (context, filterData) => {
        console.log("called customer details");
        let url = "/subscriber/v1/subscriber/ottquickpay";
        return new Promise((resolve, reject) => {
            let queryStr = ''
            queryStr = makeQueryStringDync(filterData)
            fetch(context.getters.baseUrl + url + queryStr, {
                    method: 'GET'
                })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    if (context.getters.getMode == "development") {
                        resolve({ "subscribername": "Neena Aidasani", "email": "", "mobileno": 9987505831, "susbcriberstatus": "A", "accountno": 23397361, "region": "MUM", "currentbalance": -223, "frcode": "DP0001", "customertype": "DP", "customeridentity": null })
                        return
                    }
                    reject(error)
                });
        });
    },
    submitOttQuickpay: (context, formData) => {
        let url = '/subscriber/v1/payment/init'
        return new Promise((resolve, reject) => {
            let data = makeQueryFormDataDyn(formData);
            fetch(context.getters.baseUrl + url, {
                    method: 'POST',
                    body: data
                })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    reject(error)
                });
        });
    },
};

export default {
    actions,
    state,
    getters,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/ottQuickpay.js